import React from 'react'
import { Image } from '@shared/components/image'
import cn from 'classnames'
import { useMedia } from 'use-media'

import { Back } from '../Back'

import styles from './styles.module.scss'

const CompanyCC = () => {
	const isTablet = useMedia({ minWidth: '768px' })

	return (
		<article className={styles.article}>
			<Back />
			<h1 className={styles.heading}>О компании и акционерах</h1>
			<nav className={styles.nav}>
				<ul>
					<li className={styles.navItem}>
						<a className={styles.link} href='#tech'>
							Платформа цифровых решений Credit.Club
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#cooperative'>
							КПК «Фонд Ипотечного кредитования»
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#shareholders'>
							Акционеры Credit.Club
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#documents'>
							Документы
						</a>
					</li>
				</ul>
			</nav>

			<h3 id='tech' className={styles.title}>
				Платформа цифровых решений Credit.Club
			</h3>
			<p className={styles.paragraph}>
				Credit.Club — это платформа цифровых решений для кредитования.{' '}
			</p>
			<p className={styles.paragraph}>
				У нас есть несколько направлений работы и одно из них — инвестиционное. Мы привлекаем деньги
				от инвесторов и сберегателей и направляем их в займы, которые защищены залогом квартир.
			</p>
			<p className={styles.paragraph}>
				Команда Credit.Club работает в соответствии с российским законодательством, выполняя все
				требования регулирующих организаций. Компании из группы в зависимости от стоящих перед ними
				требований находятся под надзором Банка России, саморегулируемых организаций СРО «МиР» и
				НСКК «Содействие».
			</p>

			<h3 className={styles.title}>История</h3>
			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
				В 2012 году мы зарегистрировали первую компанию из нашей группы: МКК «Магазин Кредитов».
				Тогда мы стали выдавать займы предпринимателям и частным лицам, а также увеличивать
				экспертизу в нескольких сферах:
			</p>
			<ul className={styles.list}>
				<li className={styles.item}>
					— доступного залогового кредитования и кредитных технологий,
				</li>
				<li className={styles.item}>— детальной экономической оценки недвижимости,</li>
				<li className={styles.item}>— юридической проверки заёмщика и объекта залога.</li>
			</ul>

			<p className={styles.paragraph}>
				В 2017 году мы приступили к разработке первых версий методики оценки недвижимости,
				конструктора договоров и приложения для операторов.
			</p>
			<p className={styles.paragraph}>
				К 2019 году мы трансформировались в финтех-компанию и поняли, что можем создать интересный
				платформенный сервис. В итоге в декабре этого же года запустили инвестиционную платформу,
				которая объединяет инвесторов и заёмщиков по всей России: одни могут помогать другим
				напрямую не выходя из дома.{' '}
			</p>
			<p className={styles.paragraph}>
				В 2020 году мы продолжали развивать IT-систему и совершенствовали направление инвестирования
				в залоговые займы. Выпустили на рынок два инвестиционных продукта: «Сбережения» и «Прямые
				инвестиции в бизнес». Наши клиенты получили возможность зарабатывать на инвестициях с
				повышенной надёжностью: деньги направляются в займы, которые обеспечены залогом ликвидной
				недвижимости. При этом весь процесс автоматизирован — и для нашего клиента он такой же
				простой, как обычный банковский вклад.
			</p>
			<p className={styles.paragraph}>
				2021 — год больших достижений. Мы в очередной раз подтвердили свою надёжность, пройдя
				проверку Банком России, — компания из группы Credit.Club вступила в реестр операторов
				инвестиционных платформ.{' '}
			</p>
			<p className={styles.paragraph}>
				Также одна из компаний стала участником проекта инновационного центра «Сколково».{' '}
			</p>
			<p className={styles.paragraph}>
				В этом же году мы собрали всю накопленную экспертизу, IT-разработки и создали платформу
				цифровых решений, которая делает рынок нецелевого залогового кредитования технологичнее и
				доступнее для всех сторон сделки. Это позволяет различным финансовым компаниям
				масштабироваться без открытия офисов, а клиентам — получать деньги по рыночной ставке и
				оформлять все нужные документы онлайн.
			</p>

			<h3 id='cooperative' className={styles.title}>
				КПК «Фонд Ипотечного кредитования»
			</h3>
			<p className={styles.paragraph}>
				КПК «Фонд Ипотечного Кредитования» — это кредитный потребительский кооператив, в который
				можно вложить деньги. Для работы он использует IT-систему цифровой платформы Credit.Club и
				предполагает проведение сделки в онлайне. В отличие от банковского вклада, обеспечивает
				более высокую доходность. Ставка зафиксирована на весь срок инвестирования.
			</p>
			<p className={styles.paragraph}>
				Фонд инвестирует в нецелевые ипотечные займы. Это снижает риски потери денег для самого КПК,
				а значит и для его пайщиков-сберегателей. Деньги обеспечены залогом ликвидных квартир в
				крупных городах, которые имеют цену на рынке. Если что-то идет не так, то на квартиру
				заёмщика обращают взыскание через продажу с торгов, и деньги возвращаются в фонд. При этом
				клиент-инвестор как получал доходность так и продолжит её получать: задержки платежей не
				сказываются на выплатах дохдоности.{' '}
			</p>
			<p className={styles.paragraph}>
				Размер вложений не ограничен. Инвестиции в фонд подойдут как начинающим инвесторам с
				вложениями от 100 тысяч рублей, которые хотят оценить инструмент, так и профессиональным
				участникам рынка с многомиллионным капиталом, которые стремятся диверсифицировать свой
				портфель.
			</p>

			<h3 id='shareholders' className={styles.title}>
				Акционеры Credit.Club
			</h3>
			<p className={styles.paragraph}>Наши ключевые акционеры:</p>
			<Image name={isTablet ? 'people-t.jpg' : 'people-m.png'} alt='акционеры компании' />

			<h3 id='documents' className={styles.title}>
				Документы
			</h3>
			<ol className={styles.orderedList}>
				<li className={styles.orderedItem}>
					Федеральный закон от 18.07.2009 N 190-ФЗ «О кредитной кооперации».
				</li>
				<li className={styles.orderedItem}>
					Федеральный закон от 21.12.2013 N 353-ФЗ «О потребительском кредите (займе)» для КПК,
					выдающих потребительские займы физическим лицам.
				</li>
				<li className={styles.orderedItem}>
					Федеральный закон от 16.07.1998 N 102-ФЗ «Об ипотеке (залоге недвижимости)» для КПК,
					выдающих займы под залог недвижимости.
				</li>
				<li className={styles.orderedItem}>Базовые стандарты КПК.</li>
			</ol>
		</article>
	)
}

export default CompanyCC
